import { IconCollection } from "components/Icon/IconCollection";
import { ResourceConfig } from "config/config";
import {
    deleteActionSignature,
    DeleteListAction,
    deletePermanentlyActionSignature,
    duplicateActionSignature,
    exportActionSignature,
    migrateDeprecationsActionSignature,
    MigrateDeprecationsListAction,
    moveToLocationActionSignature,
    PermanentlyDeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";

import { scriptField } from "config/resources/sharedFieldsTyped";
import {
    commentsTab,
    logsTab,
    logsTabKey,
    metadataTab,
    referencesUsedByTab,
} from "containers/Resources/screens/ResourcesSingle/constants";
import resource from "./resource";

const resourceName = "python_module";

// A python module is a library imported by flow-scripts; it is never executed on
// its own (it has no executions, input schema, priority or runtime bounds). It
// therefore mirrors the wrapper config minus every execution-specific affordance.
// Breakpoints are a runtime-debugging aid and do not apply to a non-runnable module.
const pythonModuleScriptField = {
    ...scriptField,
    fieldProps: {
        ...scriptField.fieldProps,
        breakpointsEnabled: false,
        // A python_module is a bag of functions with no single `handler`
        // entrypoint the flow-visualization model assumes, so its
        // /python_module/{id}/visualization endpoint does not exist and the
        // panel always errored ("Failed to fetch visualization"). Hide the viz
        // panel and render the script editor full-width.
        showVisualization: false,
    },
};

const config: ResourceConfig = {
    label: "Python module",
    icon: IconCollection.packageVariant,
    resourceName,
    resourceClass: "resource",
    defaultActiveTab: logsTabKey,
    layout: [
        { partial: "pageHeaderForm" },
        { partial: "form" },
        {
            partial: "tabs",
            config: {
                tabs: [logsTab.tab, commentsTab.tab, referencesUsedByTab.tab, metadataTab.tab],
                content: [logsTab.content, commentsTab.content, referencesUsedByTab.content, metadataTab.content],
            },
        },
    ],
    actions: {
        shown: [migrateDeprecationsActionSignature],
        hidden: [
            duplicateActionSignature,
            exportActionSignature,
            moveToLocationActionSignature,
            deleteActionSignature,
            deletePermanentlyActionSignature,
        ],
    },
    listActions: {
        shown: [],
        hidden: [
            { key: "delete", action: DeleteListAction },
            { key: "deletePermanently", action: PermanentlyDeleteListAction },
            { key: "migrateDeprecations", action: MigrateDeprecationsListAction },
        ],
    },
    graphql: {
        resource: resourceName,
        resourceBody: `
            ${resource.graphql.resourceBody}
            script
        `,
        // has_deprecation / has_syntax_error are intentionally omitted: as of
        // backend commit 9209968ee these columns live only on the child tables
        // that populate them, and the python_module type does not expose either —
        // requesting them fails graphql validation and breaks every python_module
        // query (single screen + advanced search). (If python_module should carry
        // has_syntax_error, that is a backend change to re-declare it on the
        // python_module table; see operator-task on the base-table narrowing.)
        resourceBodyListing: `
            ${resource.graphql.resourceBody}
        `,
        updateVariables: `
            ${resource.graphql.updateVariables(resourceName)}
            $script: String
        `,
        updateQuery: `
            ${resource.graphql.updateQuery(resourceName)}
            script: $script
        `,
        createVariables: `
            ${resource.graphql.createVariables(resourceName)}
            $script: String
        `,
        createQuery: `
            ${resource.graphql.createQuery(resourceName)}
            script: $script
        `,
    },
    form: [pythonModuleScriptField],
};
export default config;
